import type { LmsStatusTone } from "@/components/lms/lmsStatusTone";
import { LMS_STATUS_TONE_CSS } from "@/components/lms/lmsStatusTone";

export type LmsCourseStatusValue = "active" | "inactive" | "in_review";
export type LmsCourseActivationStatusValue = Exclude<
  LmsCourseStatusValue,
  "in_review"
>;

export type LmsCourseStatusPresentation = {
  tone: LmsStatusTone;
  color: string;
  backgroundColor: string;
};

const STATUS_PRESENTATIONS: Record<
  LmsCourseStatusValue,
  LmsCourseStatusPresentation
> = {
  active: {
    tone: "success",
    ...LMS_STATUS_TONE_CSS.success,
  },
  inactive: {
    tone: "error",
    ...LMS_STATUS_TONE_CSS.error,
  },
  in_review: {
    tone: "warning",
    ...LMS_STATUS_TONE_CSS.warning,
  },
};

const DEFAULT_PRESENTATION = STATUS_PRESENTATIONS.inactive;

export const getLmsCourseStatusPresentation = (
  status?: string | null,
): LmsCourseStatusPresentation => {
  const normalizedStatus = (status ?? "").trim().toLowerCase();

  if (normalizedStatus in STATUS_PRESENTATIONS) {
    return STATUS_PRESENTATIONS[normalizedStatus as LmsCourseStatusValue];
  }

  return DEFAULT_PRESENTATION;
};

export const getLmsCourseStatusOptions = (
  t: (key: string) => string,
): Array<{ value: LmsCourseActivationStatusValue; label: string }> => [
  { value: "active", label: t("active") },
  { value: "inactive", label: t("inactive") },
];
